import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import {
  NO_IMAGE_SRC,
  getInstituteStampPathFromRecord,
  resolveInstituteLogoSrc,
  resolveInstituteStampSrc,
} from '../utils/instituteBranding'

const NewInstituteSelectionModal = ({ onClose, show }) => {
  const navigate = useNavigate()
  const [selectInstitute, setSelectInstitute] = useState('') // Initialize as an empty string
  const [institutes, setInstitutes] = useState([]) // Initialize as an empty array to avoid map errors
  const [openModal, setOpenModal] = useState(false)
  // const handleClose = () => {
  //   navigate('/LoginSignup')
  //   setOpenModal(false)
  //   if (onClose) setOpenModal(false)
  // }
  useEffect(() => {
    ApiEndpoints.getAllInstitutesAssinged()
      .then((res) => {
        setInstitutes(res.data.data) // Set the list of institutes
      })
      .catch((error) => {
        toast.error('Failed to fetch institutes.')
      })
  }, [])

  const handleSelect = (e) => {
    setSelectInstitute(e.target.value)
  }

  const selectedInstitute = institutes.find(
    (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
  )
  const previewLogoSrc = selectedInstitute
    ? resolveInstituteLogoSrc(selectedInstitute.institute_logo || 'no_image.png')
    : NO_IMAGE_SRC
  const handleConfirm = async () => {
    console.log('institutes:', institutes) // ✅ Debugging log

    if (!selectInstitute) {
      toast.error('Please select an institute.')
      return
    }

    // Match using `institute_id` instead of `id`
    const institute = institutes.find(
      (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
    )

    if (!institute) {
      toast.error('Invalid Institute Selection.')
      return
    }

    const resolvedInstituteName = String(
      institute?.institute_name || institute?.name || '',
    ).trim()

     const resolvedInstituteAddress= String(
      institute?.institute_address || institute?.address || '',
    ).trim()


    if (!resolvedInstituteName) {
      toast.error('Selected institute name is invalid.')
      return
    }
    Cookies.set('institute_id', institute.institute_id, { expires: 7 })
    Cookies.set('name', resolvedInstituteName, { expires: 7 })
    Cookies.set('institute_name', resolvedInstituteName, { expires: 7 })
    Cookies.set('address', resolvedInstituteAddress, { expires: 7 })
    Cookies.set('pincode', institute?.pincode || '', { expires: 7 })
    Cookies.set('session_name', institute?.active_session?.session_name || '', { expires: 7 })
    const resolvedInstituteType = String(
      institute?.institute_type || institute?.type || '',
    )
      .trim()
      .toLowerCase()
    if (resolvedInstituteType) {
      Cookies.set('institute_type', resolvedInstituteType, { expires: 7 })
      try {
        const rawUser = Cookies.get('user')
        if (rawUser) {
          const userData = JSON.parse(rawUser)
          userData.institute_type = resolvedInstituteType
          Cookies.set('user', JSON.stringify(userData))
        }
      } catch {
        /* ignore */
      }
    }
    if (institute?.active_session?.id != null) {
      Cookies.set('academic_session_id', String(institute.active_session.id), { expires: 7 })
    } else {
      Cookies.remove('academic_session_id')
    }
    if (institute?.institute_logo) {
      Cookies.set(
        'institute_logo',
        resolveInstituteLogoSrc(institute.institute_logo),
        { expires: 7 },
      )
    } else {
      Cookies.remove('institute_logo')
    }
    const stampPath = getInstituteStampPathFromRecord(institute)
    Cookies.set('institute_stamp', resolveInstituteStampSrc(stampPath), {
      expires: 7,
    })
    Cookies.remove('stamp_url_img')
    sessionStorage.setItem('institute_confirmed', 'true')
    sessionStorage.setItem(
      'institute_confirmed_timestamp',
      Date.now().toString(),
    )
    window.location.reload()
    // onclose()
  }

  return (
    <>
      {/* Above mobile offcanvas (z-index 1300) so Switch Institute is visible without closing sidebar */}
      <style>{`
        .institute-selection-modal-backdrop {
          z-index: 1400 !important;
        }
        .institute-selection-modal {
          z-index: 1410 !important;
        }
      `}</style>
      <Modal
        show={show}
        centered
        onHide={onClose}
        className="institute-selection-modal"
        backdropClassName="institute-selection-modal-backdrop"
      >
        <Modal.Header closeButton 
          closeVariant="white"
          className="text-white" style={{ backgroundColor: '#223843' }}>
          <img
            src={previewLogoSrc}
            alt=""
            style={{
              width: 36,
              height: 36,
              marginRight: '10px',
              objectFit: 'contain',
              borderRadius: '50%',
              border: '2px solid #dee2e6',
              background: '#f8f9fa',
            }}
          />
          <Modal.Title>Select Institute</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Institute</Form.Label>
              <Form.Select onChange={handleSelect} value={selectInstitute}>
                <option value="">Select</option>
                {institutes.length > 0 ? (
                  institutes.map((inst) => (
                    <option key={inst.institute_id} value={inst.institute_id}>
                      {inst.name}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="white" style={{ backgroundColor: '#223843', color: 'white' }} onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default NewInstituteSelectionModal
